module.exports = __webpack_public_path__ + "static/media/mismatch.ac169308.svg";